"use client";

import React, { useCallback, useMemo } from "react";

import { useDynamicContext, useIsLoggedIn } from "@dynamic-labs/sdk-react-core";
import { twMerge } from "tailwind-merge";
import { SupButton, SupWallet } from "@repo/core-ui";

interface Web3AccountProps {
  fullWord?: boolean;
  className?: string;
  hideIcon?: boolean;
}

export default function Web3Account({ fullWord, className = "btn-neutral-600", hideIcon }: Web3AccountProps) {
  const { setShowAuthFlow, sdkHasLoaded, showAuthFlow } = useDynamicContext();

  const isConnected = useIsLoggedIn();

  const handleConnectWallet = useCallback(() => {
    if (!isConnected) {
      setShowAuthFlow(true);
    }
  }, [setShowAuthFlow, isConnected]);

  const isLoading = useMemo(() => !sdkHasLoaded || showAuthFlow, [sdkHasLoaded, showAuthFlow]);

  return (
    !isConnected && (
      <SupButton
        className={twMerge("right-icon whitespace-nowrap", className)}
        onClick={handleConnectWallet}
        disabled={isLoading}
        suffixIcon={hideIcon ? undefined : <SupWallet className="h-6 w-6 stroke-0" />}
      >
        {isLoading ? (
          <span>Connecting...</span>
        ) : (
          <span>
            Connect <span className={twMerge(!fullWord && "hidden lg:inline")}>Wallet</span>
          </span>
        )}
      </SupButton>
    )
  );
}
